import { Box } from '@mui/material';
import React from 'react';
import { ChromePicker } from 'react-color';
import ButtonUI from './ButtonUI';

const ChromeColorPickerUI = ({ color, onChange, removeColor }) => {
  const pickerColor = color ?? '#ffffff';
  return (
    <div className="react-color-chrome-picker">
      <ChromePicker color={pickerColor} onChange={onChange} disableAlpha />
      {removeColor && (
        <Box textAlign="center">
          <ButtonUI className="bg-danger px-2 py-1.5 m-2" text="Szín törlése" size="sm" onClick={removeColor} />
        </Box>
      )}
    </div>
  );
};

export default ChromeColorPickerUI;
